module.exports = __webpack_public_path__ + "img/user_Headportrait.dae88bc1.png";